module.exports = __webpack_public_path__ + "img/header_bg.b707126.webp";